import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import ConsosTabsComponent from 'routes/Products/components/ConsosTabsComponent'
import Chip from '@material-ui/core/Chip'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Avatar from '@material-ui/core/Avatar'
import BarIcon from '@material-ui/icons/LocalBar'
const styles = theme => ({
  chip: {
    margin: theme.spacing.unit
  },
  paperProductsEmpty: {
    marginBottom: theme.spacing.unit * 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    minHeight: 48
  },
  paperProducts: {
    marginBottom: theme.spacing.unit * 2,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
    minHeight: 48
  }
})
class AddConsosModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    transaction: PropTypes.object.isRequired,
    products: PropTypes.array,
    categories: PropTypes.array,
    addProducts: PropTypes.func.isRequired
  }
  state = {
    addedProducts: []
  }
  handleDelete = index => e => {
    const products = [...this.state.addedProducts]
    products.splice(index, 1)
    this.setState({ addedProducts: products })
  }
  handleValidate = () => {
    this.props.addProducts(this.props.transaction, this.state.addedProducts)
  }
  handleAddProduct = (undef, product) => {
    this.setState({ addedProducts: [...this.state.addedProducts, product] })
  }
  componentDidMount() {}
  render() {
    const { classes, products, categories } = this.props
    const { addedProducts } = this.state
    return (
      <ModalWrapper
        appBar
        open
        onOk={this.handleValidate}
        title={`Ajouter des Consommations`}
        cancelText="Annuler"
        okDisabled={addedProducts.length === 0}
        showOk>
        <Grid container direction="column" justify="center">
          <Grid item xs={12}>
            <Paper
              className={
                addedProducts.length === 0
                  ? classes.paperProductsEmpty
                  : classes.paperProducts
              }>
              {addedProducts.length === 0 && (
                <Typography variant="caption" gutterBottom>
                  Aucun produits sélectionnés
                </Typography>
              )}
              {this.state.addedProducts.map((p, i) => (
                <Chip
                  key={i}
                  avatar={
                    <Avatar
                      style={{ backgroundColor: p.color, color: 'white' }}>
                      <BarIcon color="inherit" />
                    </Avatar>
                  }
                  label={p.name}
                  onDelete={this.handleDelete(i)}
                  className={classes.chip}
                />
              ))}
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <ConsosTabsComponent
              products={products}
              categories={categories}
              addConso={this.handleAddProduct}
              size="medium"
            />
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(AddConsosModal)



// WEBPACK FOOTER //
// ./src/components/modals/client/AddConsosModal.js